import { render } from "./VistaCocina.vue?vue&type=template&id=81aace68&scoped=true"
import script from "./VistaCocina.vue?vue&type=script&lang=js"
export * from "./VistaCocina.vue?vue&type=script&lang=js"

import "./VistaCocina.vue?vue&type=style&index=0&id=81aace68&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81aace68"]])

export default __exports__